import { Paper, Stack, Divider, IconButton, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Flag from "../../assets/images/flag.png";
import { useWindowSize } from "../hooks/useWindowSize";

const NumberPlate = ({ plate, handleClick, canEdit }) => {

  const { isMobile } = useWindowSize();

  return (
    <Paper
      elevation={0}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid #D9D9D9",
        borderRadius: "8px",
        overflow: "hidden",
        bgcolor: "#fff",
        height: 30,
        width: "auto",
      }}
    >
      <Stack direction='row' alignItems='center' justifyContent='center' spacing={1} sx={{ px: 1 }}>
        <img src={Flag} alt='Flag' width={24} height={16} />

        <Typography 
          sx={{ 
            fontWeight: 600, 
            fontSize: 16, 
            width: "auto", 
            minWidth: 80, 
            textAlign: "center", 
            color: (plate === "" || !canEdit) && "#aaa !important" 
          }}
          onClick={canEdit ? handleClick : undefined}
        >
          {plate === "" ? "ABC-123" : plate}
        </Typography>
      </Stack>

      {canEdit && 
      <>
        <Divider orientation='vertical' flexItem />

        <IconButton
          size='small'
          onClick={handleClick}
          sx={{
            width: 30,
            height: 30,
            borderRadius: 0,
            paddingX: "8px",
          }}
        >
          <AddIcon />
        </IconButton>
      </>
    }
    </Paper>
  );
};

export default NumberPlate;
